<template>
  <span>
    <div ref="trigger" @click="show()">
      <slot name="trigger"> </slot>
    </div>
    <span ref="content" :class="{ popover: true, visible, 'md-tooltip': true }">
      <slot name="content"> </slot>
    </span>
  </span>
</template>

<script>
import { createPopper } from "@popperjs/core";

export default {
  data() {
    return {
      visible: false,
      popperInstance: null,
    };
  },
  created() {
    window.addEventListener("click", this.handleClick);
  },
  destroyed() {
    window.removeEventListener("click", this.handleClick);
  },
  mounted() {
    this.popperInstance = createPopper(this.$refs.trigger, this.$refs.content, {
      placement: "bottom",
    });
  },
  methods: {
    handleClick(e) {
      if (!this.$el.contains(e.target)) {
        this.hide();
      }
    },
    show() {
      this.popperInstance.update();
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>
<style scoped lang="scss">
.popover {
  text-align: left;
  pointer-events: initial;
  min-width: 21em;
  max-width: 100%;
  &:not(.visible) {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
